<template>
  <div class="map-input-list">
    <map-input-item
      v-for="(item, index) in optionValues"
      :key="index"
      :item="item"
      :disabledRemove="optionValues.length <= 1 ? true : false"
      @add="add"
      @remove="remove(index)"
      class="item-wrapper"
    ></map-input-item>
  </div>
</template>

<script>
import MapInputItem from "./MapInputItem"
export default {
  components: { MapInputItem },
  name: "map-input-list",
  props: {
    disabled: Boolean,
    optionValues: Array
  },
  created() {
    this.refresh()
  },
  methods: {
    refresh() {
      if (this.optionValues && this.optionValues.length == 0) {
        this.optionValues.push({ key: "", value: "" })
      }
    },
    add() {
      this.optionValues.push({ key: "", value: "" })
    },
    remove(index) {
      this.optionValues.splice(index, 1)
    }
  }
}
</script>

<style lang="scss" scoped></style>
